<template>
  <div class="wrapper">
    <van-nav-bar
      left-text="省钱记录"
      @click-left="onClickLeft"
      left-arrow
      fixed
    >
    </van-nav-bar>
    <div class="container">
      <div class="savemoney">
        <h1>累计节省(元)</h1>
        <h2>{{ moneyTotal }}</h2>
        <p>截止{{ nowdate }}</p>
      </div>
      <div class="savemoneylist">
        <div class="savediv">
          <van-row class="savelist">
            <van-col
              span="8"
              :class="{ activeitem: isActive30day }"
              @click="onSaveOf30"
              >近30天节省</van-col
            >
            <van-col
              span="8"
              :class="{ activeitem: !isActive30day }"
              @click="onSaveOf180"
              >近180天节省</van-col
            >
            <van-col span="8">
              <div
                class="savelist"
                style="text-align: right; color: grey"
                @click="onShowAllOrder"
              >
                查看全部订单>
              </div>
            </van-col>
          </van-row>
          <van-divider />
          <div class="savetip">
            近{{ isActive30day ? 30 : 180 }}天通过购买补助为您节省了 ￥{{
              moneyTotal
            }}元
          </div>
        </div>

        <div class="mylist">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
          >
            <div v-for="(item, index) in list" :key="index" class="listcell">
              <van-row>
                <van-col span="20">
                  <div>
                    <div class="van-ellipsis textstyle">
                      {{ item.title }}
                    </div>
                    <div class="van-ellipsis thedate">{{ item.time }}</div>
                  </div>
                </van-col>
                <van-col span="4">
                  <div class="van-ellipsis textstyle">￥{{ item.amount }}</div>
                </van-col>
              </van-row>
            </div>
          </van-list>
        </div>
        <van-image
          radius="5"
          class="bottomimg"
          :src="require('@/assets/images/savelife.png')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { saveMoney, saveMoneyTotal } from '@/api/productsDetaile'
export default {
  name: 'mymoney',

  data() {
    return {
      nowdate: moment().format('YYYY-MM-DD HH:mm'),
      list: [],
      loading: false,
      finished: false,
      isActive30day: true,
      listQuery: {
        current: 1,
        size: 10,
        limit: 30,
      },
      limit: 30,
      moneyTotal: 0,
      totalCount: 0,
    }
  },
  mounted() {
    this.saveTotal(this.limit)
  },
  methods: {
    onClickLeft() {
      this.$callApp('Android', 'GoBackAppMethod', '')
      this.$callApp('iOS', 'GoBackAppMethod', '')
    },
    onLoad() {
      saveMoney(this.listQuery).then((res) => {
        if (res.data.code === 200) {
          this.list = this.list.concat(res.data.data.records)
          console.log('产品列表this.list', this.list)
          this.totalCount = res.data.data.total
          this.listQuery.current++
          // 加载状态结束
          this.loading = false
          // 数据全部加载完成
          if (this.list.length >= this.totalCount) {
            this.finished = true
          }
        }
      })
    },
    saveTotal(limit) {
      saveMoneyTotal(limit).then((res) => {
        console.log('yeyyeye')
        this.moneyTotal = res.data.data
      })
    },
    onSaveOf30() {
      console.log('30')
      this.isActive30day = !this.isActive30day
      this.list = []
      this.listQuery = {
        current: 1,
        size: 10,
        limit: 30,
      }
      this.onLoad()
      this.saveTotal(30)
    },
    onSaveOf180() {
      console.log('180')
      this.isActive30day = !this.isActive30day
      this.list = []
      this.listQuery = {
        current: 1,
        size: 10,
        limit: 180,
      }
      this.onLoad()
      this.saveTotal(180)
    },
    onShowAllOrder() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoOrderListMethod', '')
        this.$callApp('iOS', 'GoOrderListMethod', '')
      }
    },
  },
}
</script>

<style lang="less" scoped>
* {
  font-size: 16px;
}

.wrapper {
  padding-top: 25px;
}

/deep/ .van-nav-bar__arrow + .van-nav-bar__text {
  font-size: 18px;
  color: black;
}
/deep/ .van-nav-bar__arrow {
  font-size: 18px;
}

.savemoney {
  padding: 2.5px;
  text-align: center;
  margin: 1px 0px;

  h1 {
    font-size: 16px;
  }

  h2 {
    font-size: 26px;
    margin: 5px 0px;
    font-weight: bold;
    color: #F44D4D;
  }

  p {
    margin-top: 10px;
    text-align: right;
    font-size: 12px;
    padding-right: 10px;
  }
}

.textstyle {
  margin: 5px 0px;
  text-align: left;
  font-size: 16px;
}

.thedate {
  text-align: left;
  font-size: 12px;
  color: #888;
  margin: 5px 0px;
}

.mylist {
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  margin: 5px 0px;
}

.listcell {
  margin: 5px 2.5px;
  padding: 2.5px 2.5px;
  border-bottom: 1px solid #eee;
}

.container {
  width: 99%;
  position: absolute;
  top: 75px;
  bottom: 0px;
  left: 0px;
}

.bottomimg {
  flex-shrink: 0;
}

/deep/.van-loading__text {
  font-size: 16px;
}

.savemoneylist {
  position: absolute;
  top: 110px;
  bottom: 0px;
  left: 0px;
  width: 100%;

  padding: 5px 1px 2.5px 1px;
  text-align: center;
  margin: 2.5px 0px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  p {
    text-align: right;
    font-size: 12px;
  }

  .savediv {
    padding: 5px 0px;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
}

.savetip {
  font-size: 15px;
  color: red;
  padding: 7px 0;
}

/deep/ .van-row {
  font-size: 12px !important;
}

/deep/ .van-divider {
  margin: 2.5px 0px;
}

.activeitem {
  color: black;
  font-weight: bold;
}

.savelist {
  color: grey;
  font-size: 15px;
  padding: 2px 0 2px;
}
</style>
